// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"332":"detail","381":"term","533":"withdraw","792":"main","887":"popup"}[chunkId] || chunkId) + "." + {"332":"5a6dc43b","381":"917d421a","533":"ecd0273a","723":"0cfbf00d","792":"0cfd6dbe","887":"e64f726b"}[chunkId] + ".css";
};